import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ViewTextToImage = ({ textToImageItem, onClose }) => {
  const data = {
    prompt: "Amazing Landscape with Sunset",
    imageUrl: "https://source.unsplash.com/400x250/?nature,water",
    aspectRatio: "16:9",
    uuid: "a1b2c3d4-e5f6-7890-gh12-i3j4k5l6m7n8",
  };

  return (
    <div className="d-flex justify-content-center align-items-center bg-gradient">
      <div className="card text-white shadow-lg p-4" style={{ width: "400px", background: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(10px)", borderRadius: "15px" }}>
        
        <div className="overflow-hidden rounded mb-3">
          <img
            src={textToImageItem?.imageUrl}
            alt="Display"
            className="img-fluid rounded"
            style={{ transition: "transform 0.3s ease-in-out" }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
        </div>

        <div className="p-2 rounded mb-2 text-dark fw-bold bg-light">
          <strong>Prompt:</strong> {textToImageItem?.prompt}
        </div>

        <div className="p-2 rounded mb-2 text-dark fw-bold bg-light">
          <strong>Aspect Ratio:</strong> {textToImageItem?.aspect_ratio}
        </div>

        <div className="p-2 rounded text-warning bg-dark small">
          <strong>UUID:</strong> {textToImageItem?.uuid}
        </div>

      </div>
    </div>
  );
};

export default ViewTextToImage;
